(function( $, doc ) {
    "use strict";

    (function(){

        $(document).ready(function(){
            
            // Form style
            $("#forminator-cform-form_style").each(function(){

                var $this = $(this),
                    $item = $this.find(".wpmudev-tabs-menu_item"),
                    $input = $item.find("input");
                
                // Default
                $item.find("#forminator-cform-form_style-material").attr("checked", true);
                $item.find("#forminator-cform-form_style-material").parent("li").addClass("current");

                $input.change(function(){

                    $input.attr("checked", false);
                    $input.parent("li").removeClass("current");

                    $(this).attr("checked", true);
                    $(this).parent("li").addClass("current");
                    
                });

            });
            
            // Fields style
            $("#forminator-cform-fields_style").each(function(){

                var $this = $(this),
                    $item = $this.find(".wpmudev-tabs-menu_item"),
                    $input = $item.find("input");
                
                // Default
                $item.find("#forminator-cform-fields_style-open").attr("checked", true);
                $item.find("#forminator-cform-fields_style-open").parent("li").addClass("current");

                $input.change(function(){

                    $input.attr("checked", false);
                    $input.parent("li").removeClass("current");

                    $(this).attr("checked", true);
                    $(this).parent("li").addClass("current");
                    
                });

            });

            // Customize typography

            // Customize font size
            $("#cform-font-size .wpmudev-tabs-menu").each(function(){

                var $this = $(this),
                    $item = $this.find(".wpmudev-tabs-menu_item"),
                    $input = $item.find("input");
                
                // Default
                $item.find("#forminator-cform-font_size-small").attr("checked", true);
                $item.find("#forminator-cform-font_size-small").parent("li").addClass("current");

                $input.change(function(){

                    $input.attr("checked", false);
                    $input.parent("li").removeClass("current");

                    $(this).attr("checked", true);
                    $(this).parent("li").addClass("current");
                    
                });

            });

            // Customize font weight
            $("#cform-font-weight .wpmudev-tabs-menu").each(function(){

                var $this = $(this),
                    $item = $this.find(".wpmudev-tabs-menu_item"),
                    $input = $item.find("input");
                
                // Default
                $item.find("#forminator-cform-font_weight-lighter").attr("checked", true);
                $item.find("#forminator-cform-font_weight-lighter").parent("li").addClass("current");

                $input.change(function(){

                    $input.attr("checked", false);
                    $input.parent("li").removeClass("current");

                    $(this).attr("checked", true);
                    $(this).parent("li").addClass("current");
                    
                });

            });

        });
        
    }());
    
}( jQuery, document ));